var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#EAEEEB",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.78503906 0.00386719 1.57007813 0.00773438 2.37890625 0.01171875 C4.4375 0.3125 4.4375 0.3125 6.4375 2.3125 C6.4375 3.3025 6.4375 4.2925 6.4375 5.3125 C3.7975 5.3125 1.1575 5.3125 -1.5625 5.3125 C-1.8925 5.9725 -2.2225 6.6325 -2.5625 7.3125 C-1.93601562 7.50585938 -1.30953125 7.69921875 -0.6640625 7.8984375 C0.56183594 8.28902344 0.56183594 8.28902344 1.8125 8.6875 C2.62460937 8.94273438 3.43671875 9.19796875 4.2734375 9.4609375 C6.4375 10.3125 6.4375 10.3125 8.4375 12.3125 C8.875 14.6875 8.875 14.6875 8.4375 17.3125 C6.25944402 19.9121152 4.60417332 21.14699993 1.20703125 21.62890625 C-2.99628069 21.73176054 -4.96585757 21.71026162 -8.5625 19.3125 C-8.5625 17.6625 -8.5625 16.0125 -8.5625 14.3125 C-2.6225 15.3025 -2.6225 15.3025 3.4375 16.3125 C3.4375 15.3225 3.4375 14.3325 3.4375 13.3125 C1.5503125 12.879375 1.5503125 12.879375 -0.375 12.4375 C-3.4164399 11.73946461 -4.86919878 11.10803415 -7.5625 9.3125 C-8.21584631 4.19462057 -8.21584631 4.19462057 -6.32421875 1.640625 C-4.07942986 -0.05167704 -2.78503988 -0.05964665 0 0 Z ",
    fill: "#20CF4D",
    transform: "translate(15.5625,4.6875)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.875 0.875 4.875 0.875 6 2 C6.375 4.3125 6.375 4.3125 6 7 C3.82194402 9.5996152 2.16667332 10.83449993 -1.23046875 11.31640625 C-5.43378069 11.41926054 -7.40335757 11.39776162 -11 9 C-11 7.35 -11 5.7 -11 4 C-5.06 4.99 -5.06 4.99 1 6 C0.67 4.02 0.34 2.04 0 0 Z ",
    fill: "#1BCE48",
    transform: "translate(18,15)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.95 0.99 4.95 0.99 10 2 C10 2.33 10 2.66 10 3 C8.02 3 6.04 3 4 3 C4 3.99 4 4.98 4 6 C6.64 6 9.28 6 12 6 C12 6.33 12 6.66 12 7 C10.5629191 7.05422947 9.12524538 7.09289723 7.6875 7.125 C6.88699219 7.14820313 6.08648437 7.17140625 5.26171875 7.1953125 C3 7 3 7 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#4BD86D",
    transform: "translate(7,19)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9.33 1.32 9.66 2.64 10 4 C7.03 3.67 4.06 3.34 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#0ACA39",
    transform: "translate(12,6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C6.66 2.33 7.32 2.66 8 3 C5.36 3 2.72 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#02C832",
    transform: "translate(11,22)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoleIcon);
export default __webpack_public_path__ + "static/media/sole-icon.02187bc7d00f63ea189d814cbd91e743.svg";
export { ForwardRef as ReactComponent };